module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [!_vm.atMain && _vm.$root.theme],
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": _vm.atMain ? 'span' : 'a'
    },
    domProps: {
      "textContent": _vm._s('mmcs meetups')
    }
  })], 1), _vm._v(" "), _c('small', {
    staticClass: "menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'new'
      }
    },
    domProps: {
      "textContent": _vm._s('Администраторам')
    }
  }), _vm._v(" "), _c('s', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Статистика")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    },
    domProps: {
      "textContent": _vm._s('О сайте')
    }
  })], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-149b6829"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 154
// module chunks = 1